import { useState, useEffect } from "react";
import { useHistory } from "react-router";

import React from 'react';
import logo from '../assets/mb-logono plus.png';

import { ToastEmitter } from "../components/DoctorMangement/ToastEmitter";
import { BackdropLoader } from "../components/DoctorMangement/BackdropLoader";
import { generateResetPasswordLink } from "../components/SPOC/Helper/API";
import { CarouselBg } from "./Carouselbg";

export const ForgotPassword = ({
}) => {
  const history = useHistory();
  const [errorHelpertext, setErrorHelpertext] = useState('');
  const [userName, setUserName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleForgotPasswordSubmit = async (e, value) => {
    try {
      setIsLoading(true);
      const resp = await generateResetPasswordLink(userName);

      if (resp.userName) {
        ToastEmitter(`Password Reset Link has be sent to the registered Email Id ${resp?.emailId}`, 'success');
        history.push("/login");
      }
      else {
        ToastEmitter(`An error occurred while sending the reset link. Please try again.`, 'error');
      }
    }
    catch (err) {
      ToastEmitter(`${err?.response?.data?.error}`, 'error')
    }
    finally {
      setIsLoading(false)
    }
  }

  const checkUsername = (e) => {
    const userName = e.target.value;
    setUserName(userName);
    if (!userName) {
      setErrorHelpertext('Please enter your username for which you want to reset password.');
      return;
    }
    //reset error 
    setErrorHelpertext('');
  }

  return (
    <>
      {isLoading && <BackdropLoader isLoading={isLoading} />}
      <div className="flex justify-center space-x-0 md:space-x-0 bg-gradient-to-l from-gray-900 via-red-900 to-gray-900">
        <div className="invisible w-0 md:visible md:w-6/12 lg:w-8/12  block m-auto ml-14 white-shadow sm:my-15 ml-0">
          <CarouselBg />
        </div>

        <div className="w-full md:w-6/12 lg:w-4/12">
          <div className="flex flex-col h-screen">
            <div className="grid place-items-center my-10 lg:pl-10 sm:my-15 mr-14 my-auto">

              <div className="w-11/12 sm:w-11/12 p-10 md:w-6/12 lg:w-11/12 :w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg">
                <div className="flex">
                  <div className="w-15-per my-auto">
                    <img src={logo} alt="logo of provider"></img>
                  </div>
                  <div className="text-lg font-semibold pl-2">
                    <span className="text-mb-blue">Medi</span>
                    <span className="text-mb-red">Buddy</span>
                    <br></br>
                    <React.Fragment>
                      <span className="text-mb-red">Provider</span>
                      <span className="text-mb-blue">Central</span>
                    </React.Fragment>
                  </div>
                </div>

                <form className="mt-10" method="submit" onSubmit={(e) => { e.stopPropagation(); e.preventDefault(); handleForgotPasswordSubmit(e); }}>
                  <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase"> Enter your Username</label>
                  <input
                    id="username"
                    type="text"
                    name="username"
                    placeholder="Username"
                    autoComplete="text"
                    onChange={(e) => checkUsername(e)}
                    className="block w-full py-3 px-1 mt-2 
                        text-gray-800 appearance-none 
                        border-b-2 border-gray-100
                        focus:text-gray-500 focus:outline-none focus:border-gray-200"
                    required
                  />

                  <button
                    className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (false ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                  >
                    Submit
                  </button>
                  <div className="text-center pt-5">
                    <p className="text-red-500 text-xs italic">{errorHelpertext}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}